import './typeform.js'
import "preline/preline";

document.addEventListener("DOMContentLoaded", function() {
	window.$ = jQuery;
	// Function to synchronize checkboxes when an .exc-form-control checkbox is clicked
	function syncFromExcToWpcf7() {
		const excCheckboxes = document.querySelectorAll('.exc-form-control input[type="checkbox"]');

		excCheckboxes.forEach(excCheckbox => {
			const checkboxClass = Array.from(excCheckbox.parentElement.classList).find(cls => cls !== 'exc-form-control');

			if (checkboxClass) {
				const matchingCheckbox = document.querySelector(`.wpcf7-checkbox#${checkboxClass} input[type="checkbox"]`);

				if (matchingCheckbox) {
					matchingCheckbox.checked = excCheckbox.checked;
				}
			}
		});
		updateSelectedCount();
	}

	// Function to synchronize checkboxes when a .wpcf7-checkbox checkbox is clicked
	function syncFromWpcf7ToExc() {
		const wpcf7Checkboxes = document.querySelectorAll('.wpcf7-checkbox input[type="checkbox"]');

		wpcf7Checkboxes.forEach(wpcf7Checkbox => {
			const checkboxId = wpcf7Checkbox.closest('.wpcf7-checkbox').id;

			if (checkboxId) {
				const matchingExcCheckbox = document.querySelector(`.exc-form-control.${checkboxId} input[type="checkbox"]`);

				if (matchingExcCheckbox) {
					matchingExcCheckbox.checked = wpcf7Checkbox.checked;
				}
			}
		});
		updateSelectedCount();
	}

	// Attach event listeners to the checkboxes in .exc-form-control
	const excCheckboxes = document.querySelectorAll('.exc-form-control input[type="checkbox"]');
	excCheckboxes.forEach(excCheckbox => {
		excCheckbox.addEventListener('change', syncFromExcToWpcf7);
	});

	// Attach event listeners to the checkboxes in .wpcf7-checkbox
	const wpcf7Checkboxes = document.querySelectorAll('.wpcf7-checkbox input[type="checkbox"]');
	wpcf7Checkboxes.forEach(wpcf7Checkbox => {
		wpcf7Checkbox.addEventListener('change', syncFromWpcf7ToExc);
	});

	// Initial synchronization on page load
	syncFromExcToWpcf7();
	syncFromWpcf7ToExc();

	function updateSelectedCount() {
		// Count the number of checked checkboxes
		let selectedCount = $('input[name="checkbox-checked"]:checked').length;

		// Update the span with the new count
		$('#exc-selected-services span').text(selectedCount);

		// Check if the selected count is 1 or more
		if (selectedCount > 0) {
			// Make the element visible if at least one service is selected
			$('#exc-selected-services').css('visibility', 'visible');
		}
		else {
			// Hide the element if no services are selected
			$('#exc-selected-services').css('visibility', 'hidden');
		}
	}

	// Attach event listener to the checkboxes
	$('input[name="checkbox-checked"]').on('change', function() {
		updateSelectedCount();
	});

	// Initial count update and visibility check (in case some checkboxes are pre-selected)
	updateSelectedCount();
});







